/**
 * Central list of feature flag keys available in the application.
 * Keep this list synchronized with all environment feature objects.
 */
export const app_feature_flags = {
  exports_job_history: 'exports_job_history',
  create_new_export_step: 'create_new_export_step',
  exports_dsp_plus_destination: 'exports_dsp_plus_destination',
  exports_scheduled_export_type: 'exports_scheduled_export_type',
  sidebar_input_or_upload_operators_hotfix:
    'sidebar_input_or_upload_operators_hotfix',
  data_refference_attributes: 'data_refference_attributes',
  // TODO: re-enable once the BE audience list endpoint supports search filtering.
  audience_list_search: 'audience_list_search',
  website_analytics: 'website_analytics',
} as const;

/** Union type for feature flag names used by the application. */
export type AppFeatureFlag =
  (typeof app_feature_flags)[keyof typeof app_feature_flags];

/** Typed map of all application feature flags and their enabled state. */
export type FeatureFlags = Record<AppFeatureFlag, boolean>;
